import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  CustomerItemTranslation,
  ItemLanguage,
  SaveItemLanguage,
} from '../models/item-language.model';

@Injectable({
  providedIn: 'root',
})
export class ItemLanguagesService {
  constructor(private http: HttpClient) {}

  getLanguages(): Observable<ItemLanguage[]> {
    return this.http.get<ItemLanguage[]>('/itemlanguages');
  }

  createLanguage(data: SaveItemLanguage): Observable<string> {
    return this.http.post<string>('/itemlanguages', data, {
      responseType: 'text' as 'json',
    });
  }

  updateLanguage(id: string, data: SaveItemLanguage): Observable<string> {
    return this.http.put<string>(`/itemlanguages/${id}`, data, {
      responseType: 'text' as 'json',
    });
  }

  deleteLanguage(id: string): Observable<string> {
    return this.http.delete<string>(`/itemlanguages/${id}`, {
      responseType: 'text' as 'json',
    });
  }

  // ECDEV-249: customer translation library (Customer page tab).
  getCustomerTranslations(
    customerId: string
  ): Observable<CustomerItemTranslation[]> {
    return this.http.get<CustomerItemTranslation[]>(
      `/companies/${customerId}/item-translations`
    );
  }

  updateCustomerTranslation(
    customerId: string,
    translationId: string,
    text: string
  ): Observable<string> {
    return this.http.put<string>(
      `/companies/${customerId}/item-translations/${translationId}`,
      { text },
      { responseType: 'text' as 'json' }
    );
  }

  deleteCustomerTranslation(
    customerId: string,
    translationId: string
  ): Observable<string> {
    return this.http.delete<string>(
      `/companies/${customerId}/item-translations/${translationId}`,
      { responseType: 'text' as 'json' }
    );
  }
}
